import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export class DocumentNumberValidator {
    protected static isValidCpf(cpf: string): boolean {
        cpf = cpf.replace(/\D/g, '');

        if (!cpf || cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
            return false;
        }

        let sum = 0, remainder;

        for (let i = 1; i <= 9; i++) {
            sum += parseInt(cpf.charAt(i - 1)) * (11 - i);
        }
        remainder = (sum * 10) % 11;
        if (remainder === 10) remainder = 0;

        if (remainder !== parseInt(cpf.charAt(9))) {
            return false;
        }

        sum = 0;
        for (let i = 1; i <= 10; i++) {
            sum += parseInt(cpf.charAt(i - 1)) * (12 - i);
        }
        remainder = (sum * 10) % 11;
        if (remainder === 10) remainder = 0;

        return remainder === parseInt(cpf.charAt(10));
    }

    protected static isValidCNPJ(cnpj: string): boolean {
        if (!cnpj || cnpj.length !== 14 || /^(\d)\1+$/.test(cnpj)) {
            return false;
        }

        let size = cnpj.length - 2;
        let numbers = cnpj.substring(0, size);
        let digits = cnpj.substring(size);
        let sum = 0, pos = size - 7;

        for (let i = size; i >= 1; i--) {
            sum += parseInt(numbers.charAt(size - i)) * pos--;
            if (pos < 2) pos = 9;
        }
        let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        if (result !== parseInt(digits.charAt(0))) {
            return false;
        }

        size = size + 1;
        numbers = cnpj.substring(0, size);
        sum = 0;
        pos = size - 7;
        for (let i = size; i >= 1; i--) {
            sum += parseInt(numbers.charAt(size - i)) * pos--;
            if (pos < 2) pos = 9;
        }
        result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
        return result === parseInt(digits.charAt(1));
    }
    public static validateDocumentNumber(control: AbstractControl): ValidationErrors | null {
        if (!control.parent) {
            return null;
        }

        const value: string = control.value?.replace(/\D/g, '');
        const form = control.parent as FormGroup;
        const type = (form.get('documentType') as FormGroup).value;

        if (!type) {
            return { invalidDocument: true };
        }

        if (value && (type === 'CPF' || value.length === 11)  && !DocumentNumberValidator.isValidCpf(value)) {
            return { invalidCPF: true };
        }

        if (value && (type === 'CNPJ' || value.length === 14) && !DocumentNumberValidator.isValidCNPJ(value)) {
            return { invalidCNPJ: true };
        }

        return null;
    }
}
